/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UserInfo } from "./UserInfo";
import {
    UserInfoFromJSON,
    UserInfoFromJSONTyped,
    UserInfoToJSON,
} from "./UserInfo";

/**
 *
 * @export
 * @interface TicketComment
 */
export interface TicketComment {
    /**
     *
     * @type {string}
     * @memberof TicketComment
     */
    ticketId?: string;
    /**
     *
     * @type {string}
     * @memberof TicketComment
     */
    commentId?: string;
    /**
     *
     * @type {UserInfo}
     * @memberof TicketComment
     */
    author?: UserInfo;
    /**
     *
     * @type {string}
     * @memberof TicketComment
     */
    comment?: string;
    /**
     *
     * @type {Date}
     * @memberof TicketComment
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof TicketComment
     */
    updatedAt?: Date;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof TicketComment
     */
    extraMetadata?: { [key: string]: string };
}

/**
 * Check if a given object implements the TicketComment interface.
 */
export function instanceOfTicketComment(value: object): value is TicketComment {
    return true;
}

export function TicketCommentFromJSON(json: any): TicketComment {
    return TicketCommentFromJSONTyped(json, false);
}

export function TicketCommentFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TicketComment {
    if (json == null) {
        return json;
    }
    return {
        ticketId: json["ticketId"] == null ? undefined : json["ticketId"],
        commentId: json["commentId"] == null ? undefined : json["commentId"],
        author:
            json["author"] == null
                ? undefined
                : UserInfoFromJSON(json["author"]),
        comment: json["comment"] == null ? undefined : json["comment"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        extraMetadata:
            json["extraMetadata"] == null ? undefined : json["extraMetadata"],
    };
}

export function TicketCommentToJSON(value?: TicketComment | null): any {
    if (value == null) {
        return value;
    }
    return {
        ticketId: value["ticketId"],
        commentId: value["commentId"],
        author: UserInfoToJSON(value["author"]),
        comment: value["comment"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        extraMetadata: value["extraMetadata"],
    };
}
